import { h } from "preact";

const IconLeft = ({ color = "#788391" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fill-rule="evenodd">
        <path fill={color} d="M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.6-4.6z" />
        <path d="M0 0h24v24H0z" />
      </g>
    </svg>
  );
};

export default IconLeft;



// WEBPACK FOOTER //
// ./assets/images/IconLeft.js